export default __webpack_public_path__ + "static/media/ic_volunteer_active.91252b29.svg";